<template>
    <div>
        <b-tab @click="tabOnClick($event, tab)" :id="`tab-id-${tab.id}${block.id}`" v-if="!inExclude(tab)">
            <template slot="title">
                {{ tab.label }} <b-badge v-if="getProducts(tab, tab.id) > 0">{{ getProducts(tab, tab.id) }}</b-badge>
            </template>
            <div v-if="tab.children">
                <b-tabs pills class="mb-4 short" content-class="mt-3 mb-4" style="font-size: 13px">
                    <ChildTab v-for="(t, key) in tab.children" :tab="t" :block="block" :key="key" v-on="$listeners"></ChildTab>
                </b-tabs>
            </div>
        </b-tab>
    </div>
</template>
<script>
let tabs = []
export default {
    props: {
        tab: Object,
        block: {
            type: Object,
            default() {
                return {
                    id: 'tab'
                };
            }
        },
    },
    components: {
        ChildTab: () => import('./Tab.vue')
    },
    data() {
        return {
            trans: trans,
        }
    },
    computed: {
        getProducts() {
            return (tab, id) => {
                if(!tabs[id]){
                    tabs[id] = 0;
                }

                // making sure to only store once as we re-render many times... could be better
                if (!tabs[`${tab.id}-${this.block}-${id}`]) {
                    tabs[`${tab.id}-${this.block}-${id}`] = 0;
                }

                if(tabs[`${tab.id}-${this.block}-${id}`] == 0) {
                    tabs[`${tab.id}-${this.block}-${id}`] = tab.items ? tab.items.length : 0;
                    tabs[id] += tab.items ? tab.items.length : 0;
                }

                if (tab.children) {
                    tab.children.map((child) => {
                        this.getProducts(child, id)
                    });
                }

                return tabs[id];
            }
        },
    },
    methods: {
        inExclude(tab){
            if (this.block && this.block.meta && this.block.meta.form && this.block.meta.form.exclude_ids) {
                if (Array.isArray(this.block.meta.form.exclude_ids) && this.block.meta.form.exclude_ids.includes(tab.id)) {
                    return true
                }
            }

            return false
        },
        tabOnClick(e, tab){
            let clickTab = tab
            if (tab.children) {
                let childs = []
                this.getChilds(childs, tab)
                childs.map((elem) => {
                    document.querySelector(`[id^="tab-id-${elem}${this.block.id}"]`).classList.remove("active")
                })
                if (tab.children && tab.children[0] && !tab.parent_id){
                    document.querySelector(`[id^="tab-id-${tab.children[0].id}${this.block.id}"]`).classList.add("active")
                    clickTab = tab.children[0];
                }
            }
            let currenct = document.querySelector(`[id^="tab-id-${tab.id}${this.block.id}"]`)
            let active = currenct.closest('.nav-pills').querySelector('.active')
            if (active != null) {
                active.classList.remove("active")
            }
            currenct.classList.add("active")
            this.$emit('tabClick', clickTab)
        },
        getChilds(childs, tab){
            childs.push(tab.id)
            if (tab.children) {
                tab.children.map((child) => {
                    this.getChilds(childs, child);
                });
            }
        },
    },
}
</script>
